import React, { useState, useEffect } from 'react';
import { EuiTextColor, EuiBadge, EuiLoadingSpinner } from '@elastic/eui';
import { useSdpdsReadOnlyOperation } from '../../hooks/useSdpdsReadOnlyOperation';

export const ClusterFeature = (props) => {
  const [isRequestActive, setIsRequestActive] = useState(true);
  const [features, setFeatures] = useState([]);
  const [exception, setException] = useState('');
  const [nextToken, setNextToken] = useState(null);

  const { data, error } = useSdpdsReadOnlyOperation({
    operation_name: "ListFeatures",
    payload: {
      cluster: {
        stackName: props.stackName,
        clusterId: props.clusterId,
      },
      maxResults: 100,
      nextToken: nextToken,
    }
  });

  const updateResponse = (response) => {
    if (response) {
      const newFeatures = response.featureList.map(feature => feature.featureTag);
      setFeatures(prevFeatures => [...prevFeatures, ...newFeatures]);

      if (response.nextToken) {
        setNextToken(response.nextToken);
      } else {
        setIsRequestActive(false);
      }
    }
  };

  useEffect(() => {
    if (error) {
      setException(error.message || JSON.stringify(error));
      setIsRequestActive(false);
    } else if (data?.sdpdsReadOnlyOperation) {
      updateResponse(data.sdpdsReadOnlyOperation);
    }
  }, [data, error]);

  useEffect(() => {
    setFeatures([]);
    setNextToken(null);
    setIsRequestActive(true);
    setException('');
  }, [props.stackName, props.clusterId]);

  if (isRequestActive) {
    return <EuiLoadingSpinner size="l" id="loadingSpinner" />;
  } else if (exception) {
    return <EuiTextColor color="danger">{exception}</EuiTextColor>;
  } else {
    return (
      <div>
        {features.map((feature) => (
          <EuiBadge key={feature} color={'primary'}>
            {feature}
          </EuiBadge>
        ))}
      </div>
    );
  }
};
